export enum AnalysisCategory {
    SINGLE = 'SINGLE',
    GROUP = 'GROUP',
    SUPPORT = 'SUPPORT',
    TEMPLATE = 'TEMPLATE',
    ALL = 'ALL'
}
